<template>
  <div v-if="amReady">
    <app-board class="mb-2">
      <el-row class="pt-1 pl-2 pr-2 m-0">
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" class="m-0">
          <dg-select-field
              :control="control"
              :field_span="22"
            :label_span="22"
              :options="destinationsDropDownList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="destinationChanged"
              class="m-0"
              field_mark="required"
              htmlautocomplete="new-password"
              label="Destination"
              labelProperty="label"
              name="destination_id"
              placeholder="Canada / ATI"
              rules="required"
              valueProperty="value"
          ></dg-select-field>
        </el-col>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6"
                class="m-0" v-if="!$store.getters['user-state/isUserCustomer']">
          <dg-select-field
              :control="control"
              :field_span="16"
              :label_span="24"
              :options="vendorsList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="vendorChanged"
              class="m-0"
              field_mark="required"
              label="Vendor"
              name="vendor_id"
              rules="required"></dg-select-field>
        </el-col>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" class="pt-2 m-0">
          <dg-button :click="resetSearchFields" :translate="false" class="mr-2 mt-4" fieldSize="mini"
                     icon="el-icon-refresh"
                     text="Reset Search" type="primary"></dg-button>
        </el-col>
      </el-row>
    </app-board>

    <app-board class="mb-2" :header="false">
      <div class="row pt-2">
        <div class="col-12 col-md-4">
          <span style="position: absolute"> Search </span>
          <dg-text-field
              :field_span="22"
              :label_span="22"
              :liveUpdate="true"
              @amUpdated="userSearchUpdated"
              class="m-0 p-0"
              field_mark=""
              placeholder="Search by destination and dialcode"></dg-text-field>
        </div>
        <div class="col-12 col-md-5">
          <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
        </div>
        <div class="col-12 col-md-3 text-right">
          <downloadWorkingDestinationsButton></downloadWorkingDestinationsButton>
        </div>
      </div>
    </app-board>

    <app-board>
      <app-ag-grid :agGrid="agGrid"></app-ag-grid>
    </app-board>
  </div>
</template>

<script>

import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import callTestStatusViewer from "@/components/call-test-status-viewer/View";
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';

let globalContext = null
export default {
  mixins: [fieldController],
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    downloadWorkingDestinationsButton: () => import('@/components/download-working-destinations/View')
  },
  data() {
    return {
      userSearchTimeOut: null,
      hasColumnBeenResized: 213,
      dataModel: {
        destination_id: '',
        vendor_id: ''
      },
      amReady: false,
      module: {
        ...module
      },
      control: this,
      vendorsList: [],
      destinationsDropDownList: [],
      userSearch: '',
      currentPage: 1,
      pageChunkSize: 20,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            setTimeout(() => {
              params.api.sizeColumnsToFit()
            }, 200)
          },
          onColumnResized: function (params) {
            if (!globalContext.hasColumnBeenResized) {
              //params.api.sizeColumnsToFit()
              globalContext.hasColumnBeenResized = true
            }
          }
        },
        columnDefs: [
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'vendor',
            headerName: (($store.getters['user-state/isUserCustomer']) ? 'Prefix' : 'Vendor'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'division',
            width: 120,
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'dialcode',
            width: 100,
            headerName: 'Dialcode',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          }
          ,/*
          {
            width: 80,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }*/
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    if ($store.getters['user-state/isUserRoot']) {
      this.agGrid.columnDefs.push({
        field: 'rate',
        width: 120,
        headerName: 'Rate',
        headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
        autoHeight: true
      })
    }

    if ($store.getters['user-state/isUserRoot'] || $store.getters['user-state/isUserPlatformEmployee'] || $store.getters['user-state/isUserAdmin']) {
      this.agGrid.columnDefs.push({
        field: 'prefix',
        width: 100,
        headerName: 'Prefix',
        headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
        autoHeight: true
      })
    }


    this.agGrid.columnDefs.push({
      field: 'created_at',
      width: 120,
      headerName: 'Time',
      headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
      autoHeight: true
    })


    this.agGrid.columnDefs.push({
      field: 'status',
      width: 120,
      headerName: 'Status',
      headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
      autoHeight: true,
      cellRendererFramework: $vue.extend(callTestStatusViewer),
      cellRendererParams: {
        props: {
          actionsHandler: this.actionsHandler
        }
      }
    })

    globalContext = this;
    this.getVendorDropDownList().then(r => {
      this.vendorsList = r
    })

    this.getDestinationsDropdownlist().then((r) => {
      this.destinationsDropDownList = r
      this.amReady = true
    })

    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    getEntityListData(page) {
      this.getEntityList({
        page: page,
        destination_id: this.dataModel.destination_id,
        vendor_id: this.dataModel.vendor_id,
        search: this.userSearch
      }).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true
    },
    resetSearchFields() {
      this.fields['destination_id'].field.field_value = ''
      this.fields['destination_id'].field.updateValue()
      this.fields['destination_id'].field.validateMessage = ''

      this.fields['vendor_id'].field.field_value = ''
      this.fields['vendor_id'].field.updateValue()
      this.fields['vendor_id'].field.validateMessage = ''

      this.userSearch = ''
      this.dataModel.destination_id = ''
      this.dataModel.vendor_id = ''
      this.getEntityListData(this.currentPage)
    },
    destinationChanged() {
      this.getEntityListData(this.currentPage)
    },
    vendorChanged() {
      this.getEntityListData(this.currentPage)
    },
    ...$mapActions('voip-vendor-api', {
      getVendorDropDownList: 'getDropDownList'
    }),
    ...$mapActions('voip-destination-api', {
      getDestinationsDropdownlist: 'getDropDownList'
    }),
    ...$mapActions('voip-vendor-destination-status-api', {
      getEntityList: 'list'
    }),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
